const testimonialsSlider = document?.querySelectorAll(".testimonials-slider");

testimonialsSlider?.forEach((item) => {
  const sliderEl = item?.querySelector(".keen-slider");
  if (sliderEl) {
    const slider = new KeenSlider(sliderEl, {
      breakpoints: {
        "(min-width: 580px)": {
          slides: { perView: 2, spacing: 20 },
        },
        "(min-width: 900px)": {
          slides: { perView: 3, spacing: 20 },
        },
        "(min-width: 1280px)": {
          slides: { perView: 3, spacing: 50 },
        },
      },
      slides: { perView: 1 },
    });
    const prevBtn = item?.querySelector(".prev");
    const nextBtn = item?.querySelector(".next");
    prevBtn?.addEventListener("click", function () {
      slider.prev();
    });
    nextBtn?.addEventListener("click", function () {
      slider.next();
    });
  }
});
